import { useState, useEffect } from 'react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: "Sophie & Alexandre",
      event: "Mariage - Château de Versailles",
      rating: 5,
      text: "L'Art des Mets a transformé notre mariage en un moment magique. Chaque plat était une œuvre d'art, nos invités en parlent encore ! Le service était impeccable et l'équipe d'une gentillesse remarquable.",
      date: "Septembre 2024"
    },
    {
      name: "Marie Dubois",
      event: "Événement Corporate - La Défense",
      rating: 5,
      text: "Pour notre séminaire d'entreprise, nous cherchions l'excellence. L'Art des Mets a dépassé toutes nos attentes avec un service irréprochable et une cuisine raffinée qui a impressionné tous nos clients.",
      date: "Octobre 2024"
    },
    {
      name: "Jean-Pierre Martin",
      event: "Anniversaire - Paris 16ème",
      rating: 5,
      text: "Un service de traiteur exceptionnel ! La présentation était magnifique, les saveurs sublimes. Nos 80 invités ont été conquis. Je recommande vivement pour tous vos événements prestigieux.",
      date: "Août 2024"
    },
    {
      name: "Isabelle Moreau",
      event: "Défilé de Mode - Palais Galliera",
      rating: 5,
      text: "L'Art des Mets comprend parfaitement l'univers de la mode. Leur créativité culinaire s'harmonise parfaitement avec nos événements. Un partenaire de confiance pour nos défilés parisiens.",
      date: "Novembre 2024"
    },
    {
      name: "Thomas & Camille",
      event: "Fiançailles - Neuilly-sur-Seine",
      rating: 5,
      text: "Une soirée inoubliable grâce à L'Art des Mets ! Chaque détail était parfait, de l'amuse-bouche au dessert. L'équipe s'est adaptée à toutes nos demandes avec professionnalisme.",
      date: "Juillet 2024"
    },
    {
      name: "Catherine Leroy",
      event: "Cocktail d'entreprise - Musée d'Orsay",
      rating: 5,
      text: "Pour notre événement au Musée d'Orsay, nous avions besoin d'un traiteur à la hauteur du lieu. L'Art des Mets a créé une expérience culinaire mémorable, digne du cadre exceptionnel.",
      date: "Décembre 2024"
    },
    {
      name: "Philippe & Margaux",
      event: "Mariage - Château de Versailles, L'Orangerie",
      rating: 5,
      text: "Notre réception à l'Orangerie du Château de Versailles était un rêve devenu réalité grâce à L'Art des Mets. La gastronomie était à la hauteur de ce lieu d'exception. Un moment inoubliable pour nos 200 invités.",
      date: "Juin 2024"
    },
    {
      name: "Laurent Beaumont",
      event: "Gala d'entreprise - Pavillon d'Armenonville",
      rating: 5,
      text: "Le Pavillon d'Armenonville méritait un traiteur d'excellence, et L'Art des Mets a été parfait. Service impeccable, cuisine raffinée et présentation spectaculaire. Nos partenaires ont été éblouis.",
      date: "Octobre 2024"
    },
    {
      name: "Nathalie & Christophe",
      event: "Anniversaire - Salle Wagram",
      rating: 5,
      text: "Pour nos 50 ans à la Salle Wagram, L'Art des Mets a orchestré un banquet somptueux. 300 invités conquis par la qualité des mets et l'organisation sans faille. Une équipe exceptionnelle !",
      date: "Mai 2024"
    },
    {
      name: "Société Prestige Events",
      event: "Lancement produit - Espace Georges V",
      rating: 5,
      text: "L'Espace Georges V accueillait notre lancement de produit de luxe. L'Art des Mets a su créer une expérience culinaire à la hauteur de nos exigences. Élégance, raffinement et créativité au rendez-vous.",
      date: "Septembre 2024"
    },
    {
      name: "Maison LANVIN",
      event: "Défilé Haute Couture - LANVIN",
      rating: 5,
      text: "Pour notre défilé haute couture, L'Art des Mets a créé une expérience gastronomique aussi raffinée que nos créations. Leur sens du détail et leur créativité correspondent parfaitement à l'esprit LANVIN.",
      date: "Mars 2024"
    },
    {
      name: "École des Beaux-Arts",
      event: "Vernissage - École des Beaux-Arts",
      rating: 5,
      text: "Notre vernissage annuel à l'École des Beaux-Arts a été sublimé par L'Art des Mets. Leur cuisine est un véritable art qui s'harmonise parfaitement avec notre univers créatif. Un partenariat réussi.",
      date: "Janvier 2024"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400 text-lg`}
      />
    ));
  };

  return (
    <section id="avis" className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-300 mb-8" style={{ fontFamily: 'Alice, serif' }}>
            Avis Clients
          </h2>
          
          <div className="flex items-center justify-center mb-8">
            <div className="w-24 h-px bg-gray-300"></div>
            <div className="w-4 h-4 bg-gray-300 rounded-full mx-6 rotate-45"></div>
            <div className="w-24 h-px bg-gray-300"></div>
          </div>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Découvrez les témoignages de nos clients qui nous font confiance pour leurs événements d'exception
          </p>
        </div>

        {/* Statistiques */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-300 mb-2" style={{ fontFamily: 'Alice, serif' }}>
              500+
            </div>
            <div className="text-gray-400">Événements réalisés</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-300 mb-2" style={{ fontFamily: 'Alice, serif' }}>
              4.9/5
            </div>
            <div className="text-gray-400">Note moyenne</div>
            <div className="flex justify-center mt-2">
              {renderStars(5)}
            </div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gray-300 mb-2" style={{ fontFamily: 'Alice, serif' }}>
              98%
            </div>
            <div className="text-gray-400">Clients satisfaits</div>
          </div>
        </div>

        {/* Témoignages */}
        <div className="relative max-w-4xl mx-auto">
          <div className="bg-gray-800/50 rounded-2xl p-8 md:p-12 border border-gray-700">
            <div className="text-center mb-8">
              <div className="flex justify-center mb-4">
                {renderStars(testimonials[currentIndex].rating)}
              </div>
              
              <blockquote className="text-xl md:text-2xl text-gray-200 leading-relaxed mb-8 italic">
                "{testimonials[currentIndex].text}"
              </blockquote>
              
              <div className="border-t border-gray-600 pt-6">
                <div className="text-lg font-semibold text-white mb-1" style={{ fontFamily: 'Alice, serif' }}>
                  {testimonials[currentIndex].name}
                </div>
                <div className="text-gray-400 mb-1">
                  {testimonials[currentIndex].event}
                </div>
                <div className="text-gray-500 text-sm">
                  {testimonials[currentIndex].date}
                </div>
              </div>
            </div>
          </div>

          {/* Indicateurs */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex 
                    ? 'bg-gray-300 scale-125' 
                    : 'bg-gray-600 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Grille de témoignages */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-800/30 rounded-lg p-6 border border-gray-700 hover:border-gray-600 transition-all duration-300"
            >
              <div className="flex justify-between items-start mb-4">
                <div className="flex">
                  {renderStars(testimonial.rating)}
                </div>
                <div className="text-gray-500 text-sm">
                  {testimonial.date}
                </div>
              </div>
              
              <p className="text-gray-300 mb-4 text-sm leading-relaxed">
                "{testimonial.text.substring(0, 120)}..."
              </p>
              
              <div className="border-t border-gray-700 pt-4">
                <div className="font-semibold text-white text-sm" style={{ fontFamily: 'Alice, serif' }}>
                  {testimonial.name}
                </div>
                <div className="text-gray-400 text-xs">
                  {testimonial.event}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
